export default __webpack_public_path__ + "static/media/Element1.9992f9a1.png";